import React from 'react';
import { Box, Container, Typography, Button, Link } from '@mui/material';
import ClassificationBannerHeader from '../../common/banner/classifactionBannerHeader';
import PageHeader from '../../common/banner/pageHeader';
import { useNavigate } from 'react-router-dom';
import ComplianceDashboard from '../../common/buttons/complianceDash';

export default function CISOverview() {

  const baseRoute = process.env.REACT_APP_BASE_ROUTE || '/';
  const imgRoute = 'images/analytics/cis.png';
  const route = baseRoute + imgRoute;
  const navigate = useNavigate();
  const handleResponse = (() => {
    navigate('/cisDetails')
  });
  
  return (
    <Container sx={{ minWidth:1800, mt: 10, mb: 10 }}>
      <Box sx={{pt: 2}}>
        <ClassificationBannerHeader></ClassificationBannerHeader>
        <PageHeader title="CCG Dashboards"></PageHeader>
      </Box>
      <Typography variant='h4' 
        sx ={{display: 'flex', 
              alignItems: 'center', 
              justifyContent: 'center', 
              fontSize: '1.35em', 
              marginBottom: '10px'}}>
        CIS Overview
      </Typography>
      <ComplianceDashboard></ComplianceDashboard>
      <Box
        sx={{          
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          flexDirection: 'column'
        }}
      >
      <img 
          alt="CIS Info"
          src={route}
          width="100%"
          height="100%"
          style={{ border: 'none', display: 'flex', objectFit: 'none', marginTop: '-10px', marginBottom: '-70px' }}
      />
      <Button
        onClick={handleResponse}
        sx={{ 
          fontSize: '0.75rem',
          marginLeft: "-1180px", 
          marginTop: '22px',
          marginBottom: '-50px',
          color: '#FFF', 
          bgcolor: '#606662' , 
          height: '22px', 
          '&:hover': {
              backgroundColor: '#1f1e1d',
          } }}>
        sensor 001
      </Button>
      </Box>
    </Container>
  );
};